var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 682 682.67",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8f8f8f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m585.91 640h-469.33c-11.781 0-21.332-9.5508-21.332-21.332v-277.34c0-5.8867 4.7734-10.664 10.664-10.664s10.668 4.7773 10.668 10.664v277.34h469.33v-597.34h-469.33v120.64c0 5.8945-4.7773 10.668-10.668 10.668s-10.664-4.7734-10.664-10.668v-120.64c0-11.781 9.5508-21.332 21.332-21.332h469.33c11.781 0 21.332 9.5508 21.332 21.332v597.34c0 11.781-9.5508 21.332-21.332 21.332zm-32-42.664h-405.34c-5.8867 0-10.664-4.7773-10.664-10.672v-138.66c0-5.8906 4.7773-10.664 10.664-10.664h405.34c5.8906 0 10.664 4.7734 10.664 10.664v138.66c0 5.8945-4.7734 10.672-10.664 10.672zm-394.67-21.336h384v-117.33h-384zm394.67-160h-405.34c-5.8867 0-10.664-4.7734-10.664-10.668v-64c0-5.8867 4.7773-10.664 10.664-10.664 5.8945 0 10.668 4.7773 10.668 10.664v53.336h384v-330.67h-394.67c-5.8867 0-10.664-4.7773-10.664-10.664 0-5.8945 4.7773-10.672 10.664-10.672h405.34c5.8906 0 10.664 4.7773 10.664 10.672v352c0 5.8945-4.7734 10.668-10.664 10.668z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m553.91 416h-405.34c-5.8867 0-10.664-4.7734-10.664-10.668v-64c0-5.8867 4.7773-10.664 10.664-10.664 5.8945 0 10.668 4.7773 10.668 10.664v53.336h384v-330.67h-394.67c-5.8867 0-10.664-4.7773-10.664-10.664 0-5.8945 4.7773-10.672 10.664-10.672h405.34c5.8906 0 10.664 4.7773 10.664 10.672v352c0 5.8945-4.7734 10.668-10.664 10.668z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m553.91 597.34h-405.34c-5.8867 0-10.664-4.7773-10.664-10.672v-138.66c0-5.8906 4.7773-10.664 10.664-10.664h405.34c5.8906 0 10.664 4.7734 10.664 10.664v138.66c0 5.8945-4.7734 10.672-10.664 10.672zm-394.67-21.336h384v-117.33h-384z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m553.91 416h-405.34c-5.8867 0-10.664-4.7734-10.664-10.668v-64c0-5.8867 4.7773-10.664 10.664-10.664 5.8945 0 10.668 4.7773 10.668 10.664v53.336h384v-330.67h-394.67c-5.8867 0-10.664-4.7773-10.664-10.664 0-5.8945 4.7773-10.672 10.664-10.672h405.34c5.8906 0 10.664 4.7773 10.664 10.672v352c0 5.8945-4.7734 10.668-10.664 10.668z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m415.24 352h-405.33c-3.668-0.003906-7.082-1.8906-9.0312-5-1.9453-3.1016-2.1602-6.9922-0.57422-10.297l138.67-288c1.7773-3.6914 5.5078-6.0352 9.5977-6.043h405.34c3.668 0.007813 7.0781 1.8906 9.0234 4.9961 1.9492 3.1133 2.168 6.9961 0.57812 10.305l-138.67 288c-1.7773 3.6875-5.5078 6.0352-9.5977 6.0391zm-388.37-21.332h381.67l128.39-266.67h-381.66z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m388.43 309.33h-310.62c-3.668 0-7.0781-1.8906-9.0234-4.9961-1.9492-3.1055-2.168-6.9961-0.57812-10.297l97.59-202.67c1.7773-3.6914 5.5078-6.0352 9.5977-6.0391h310.62c3.668 0.003907 7.0742 1.8906 9.0234 5 1.9531 3.1055 2.168 6.9922 0.57812 10.297l-97.59 202.67c-1.7773 3.6875-5.5078 6.0352-9.5977 6.0352zm-293.64-21.332h286.93l87.305-181.34h-286.93z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m553.91 597.34h-405.34c-5.8867 0-10.664-4.7773-10.664-10.672v-138.66c0-5.8906 4.7773-10.664 10.664-10.664h405.34c5.8906 0 10.664 4.7734 10.664 10.664v138.66c0 5.8945-4.7734 10.672-10.664 10.672zm-394.67-21.336h384v-117.33h-384z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m553.91 266.66c-2.832 0-5.5391-1.1211-7.543-3.125l-64-64c-4.043-4.1836-3.9844-10.836 0.13281-14.949 4.1133-4.1172 10.766-4.1758 14.953-0.13281l63.996 64c3.0547 3.0508 3.9648 7.6406 2.3164 11.625-1.6523 3.9844-5.543 6.582-9.8555 6.582z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m287.24 416c-2.8281 0-5.5391-1.125-7.5391-3.125l-64-64c-4.043-4.1875-3.9844-10.836 0.12891-14.953 4.1133-4.1133 10.77-4.1719 14.953-0.12891l64 64c3.0469 3.0508 3.9609 7.6367 2.3086 11.621-1.6484 3.9844-5.5352 6.5859-9.8516 6.5859z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowDisabled);
export default __webpack_public_path__ + "static/media/window_disabled.b2b064e9e1618d92eb1bde2688f1c406.svg";
export { ForwardRef as ReactComponent };